export default __webpack_public_path__ + "8fdb0184466cceda8a08a29a73787364.png";